import React from 'react';
import { Card, HideOnMobile, HideOnTablet } from 'quanta-ui';
import { GET_BUY_FIRE_POLICY_VAR_DETAILS } from '../queries';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
import { useQuery } from '@apollo/client';
import FireProposalSummary from './proposal-summary-fire';

export default function FireSummaryPanel({
  productName,
  productCode,
  lobCode,
}) {
  const { loading, error, data } = useQuery(
    GET_BUY_FIRE_POLICY_VAR_DETAILS,
  );
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <div className="flex flex-col justify-start h-auto sticky top-0">
      <HideOnMobile className="w-full">
        <HideOnTablet className="w-full">
          <Card
            className={`h-full xl:h-auto p-0 m-0`}
            title="Proposal"
          >
            {data && (
              <FireProposalSummary
                data={data}
                lobCode={lobCode}
                productName={productName}
                productCode={productCode}
              />
            )}
          </Card>
        </HideOnTablet>
      </HideOnMobile>
      <div className="xl:hidden w-full">
        {data && (
          <FireProposalSummary
            data={data}
            lobCode={lobCode}
            productName={productName}
            productCode={productCode}
          />
        )}
      </div>
    </div>
  );
}
